
import en from "./en.json"
import ar from "./ar.json"
export const LanguageJSON={
    en,
    ar
}


// WEBPACK FOOTER //
// ./src/languageJson/index.js